import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class DiagnosticPageViewedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.DIAGNOSTIC_PAGE_VIEWED;

  formId: string;

  constructor(formId: string) {
    super();
    this.formId = formId;
  }
}
